import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fromIntersectionObserver, IntersectionStatus } from './from-intersection-observer';

@Directive({
  selector: '[visibilityObserver]'
})
export class VisibilityObserverDirective implements OnInit, OnDestroy {
  @Input() intersectionThrottle = 250;
  @Input() intersectionRoot: HTMLElement;

  @Output() visibilityChange = new EventEmitter<IntersectionStatus>();

  private destroy$ = new Subject<void>();

  constructor(private element: ElementRef) {
  }

  ngOnInit() {
    const element = this.element.nativeElement;
    const config = {
      root: this.intersectionRoot
    };

    fromIntersectionObserver(
      element,
      config,
      this.intersectionThrottle
    ).pipe(
      takeUntil(this.destroy$)
    ).subscribe(status => {
      this.visibilityChange.emit(status);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}
